import {
  ATLAS_MENU_ITEM,
  ATLAS_MENU_ITEM_DANGER,
  formatButtonLabel,
} from "./atlasButtonStyles";

const DESTRUCTIVE_LABEL = /^(delete|remove)(\s|$)/i;

export function resolveDropdownMenuItemVariant(action = {}) {
  if (action.danger === true || action.variant === "danger") return "danger";
  if (action.variant === "default") return "default";

  const label = String(action.label || "").trim();
  if (DESTRUCTIVE_LABEL.test(label)) return "danger";

  if (action.className && /\btext-red(-\d+)?\b/.test(action.className)) {
    return "danger";
  }

  return "default";
}

export default function AtlasDropdownMenuItem({
  label,
  onClick,
  disabled = false,
  variant = "default",
  className = "",
}) {
  const baseClass =
    variant === "danger" ? ATLAS_MENU_ITEM_DANGER : ATLAS_MENU_ITEM;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[baseClass, className].filter(Boolean).join(" ")}
    >
      {formatButtonLabel(label)}
    </button>
  );
}
